import { Pipe, PipeTransform } from '@angular/core';

import { EmployeeInfo } from 'services/application/application.service';
import { TitleCasePipe } from 'pipes/titlecase.pipe';

@Pipe({
    name: 'nominee'
})
export class NomineePipe implements PipeTransform {
    constructor(private titleCasePipe: TitleCasePipe) { }

    transform(emp: EmployeeInfo) {
        if (!emp) { return ''; }

        let name = this.titleCasePipe.transform(emp.FirstName) + ' '
            + this.titleCasePipe.transform(emp.LastName);

        if (emp.LocalJobTitle) {name += ' (' + emp.LocalJobTitle + ')'; }

        return name;
    }
}
